import utilsApi from '../../assets/js/utils';

import config from '../config/index';

export default utilsApi.creatApi({
    // 绑定账号
    bindAccount: ['post', config.battleFieldUrl + '/battlefield2042Tracker/bind'],
    // 获取绑定用户信息
    getBindInfo: ['post', config.battleFieldUrl + '/battlefield2042Tracker/getUserBindInfo'],
    // 查询战绩信息
    getTrackeInfo: ['get', config.battleFieldUrl + '/battlefield2042Tracker/getTrackerInfo'],
    // 解除绑定账号
    unBindAccount: ['post', config.battleFieldUrl + '/battlefield2042Tracker/unbind'],


   // 获取武器战绩列表
    getWeaponList: ['post', config.battleFieldUrl + '/weaponTracker/getAllWeapon'],
    // 获取单个武器战绩
    getWeaponDetail: ['post', config.battleFieldUrl + '/weaponTracker/getWeapon'],

    // 获取获取专家战绩列表
    getClassList: ['post', config.battleFieldUrl + '/specialistTracker/getAllSpecialist'],

    // 获取获取专家战绩
    getclassDetail: ['post', config.battleFieldUrl +'/specialistTracker/getSpecialist'],

    // 获取获取载具战绩列表
    getVehicleList: ['post', config.battleFieldUrl + '/vehicleTracker/getAllVehicle'],
    // 获取单个载具战绩
    getVehicleDetail: ['post', config.battleFieldUrl + '/vehicleTracker/getVehicle'],

    // 获取获取特殊武器战绩列表
    getGadgetList: ['post', config.battleFieldUrl + '/gadgetTracker/getAllGadget'],
    // 获取单个特殊武器战绩
    getGadgetDetail: ['post', config.battleFieldUrl + '/gadgetTracker/getGadget'],

    // 获取所有武器类型列表
    getAllWeaponGroup: ['post', config.battleFieldUrl + '/weaponGroupTracker/getAllWeaponGroup'],
    // 获取指定武器类型战绩信息
    getWeaponGroup: ['post', config.battleFieldUrl + '/weaponGroupTracker/getWeaponGroup'],

    // 获取所有载具类型列表
    getAllVehicleGroup: ['post', config.battleFieldUrl +'/vehicleGroupTracker/getAllVehicleGroup'],
    // 获取指定载具类型战绩信息
    getVehicleGroup: ['post', config.battleFieldUrl + '/vehicleGroupTracker/getVehicleGroup'],

    // 获取全部游戏模式
    getAllGameMode: ['post', config.battleFieldUrl + '/modeTracker/getAllMode'],

    // 获取指定游戏模式战绩
    getGameMode: ['post', config.battleFieldUrl + '/modeTracker/getMode'],

    // 获取全部地图模式
    getAllMap: ['post', config.battleFieldUrl +'/mapTracker/getAllMap'],
    // 获取指定地图模式战绩
    getMap: ['post', config.battleFieldUrl + '/mapTracker/getMap'],

    // 获取战地2042用户作弊标记信息
    getUserLabelInfo: ['post', config.battleFieldUrl + '/userCheaterLabel/info'],

    // 获取当前用户已标记对应用户的作弊标签
    getUserLabelTags: ['post', config.battleFieldUrl + '/userCheaterLabel/userLabelTags'],

    // 保存用户作弊标签
    saveUserLabel: ['post', config.battleFieldUrl + '/userCheaterLabel/save'],

    // 

});